<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto pt-4">
            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
                <Notifica v-for="n in notifiche" :key="n.id"
                          :id="n.id"
                          @read="fetchNotification"
                          :date="$filters.toDate(n.created_at)"
                          :testoNotifica="getTextNotifica(n)"
                          colore-attivo="bg-white"
                          :mark_as_read="n.data?.markable"
                          :to="getLinkNotifica(n)"
                >
                </Notifica>

            </div>
            <div class="py-4 flex items-center justify-between">
                <div class="text-3xl font-bold">Il tuo profilo</div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-3">
                <div class="flex flex-col">
                    <Field v-model="user_model.name" field_name="Nome" :errors="getErrors('name')"></Field>

                </div>
                <div class="flex flex-col">
                    <Field field_name="Giorno di assunzione" :errors="getErrors('giorno_assunzione')">
                        <input v-model="user_model.giorno_assunzione" type="date"
                               class="flex-grow p-7px bg-next-gray-md-dark hover:bg-white">
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field v-model="user_model.telefono" field_name="Numero di telefono" :errors="getErrors('telefono')"></Field>
                </div>
                <div class="flex flex-col">
                    <Field v-model="user_model.ruolo" field_name="Ruolo" :errors="getErrors('ruolo')"></Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Data di nascita" :errors="getErrors('nascita')">
                        <input v-model="user_model.nascita" type="date"
                               class="flex-grow p-7px bg-next-gray-md-dark hover:bg-white">
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field v-model="user_model.dipartimento" field_name="Dipartimento" :errors="getErrors('dipartimento')"></Field>
                </div>
                <div class="flex flex-col">
                    <Field v-model="user_model.contatto_emergenza" field_name="Contatto di emergenza" :errors="getErrors('contatto_emergenza')"></Field>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import Notifica from "@/components/Notifica.vue";
import userManager from "../api/Users";
import meManager from "../api/Me";
import {mapActions} from 'vuex';
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import {TipoNotifica} from "@/types";
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";

@Options({
    name:'ProfiloUtente',
    components: {
        Field,
        NextButton,
        Notifica,
        Topbar
    },
    methods: {
        ...mapActions([
            'logout',
        ]),
    }
})
export default class ProfiloUtente extends Vue {

    logout!: any
    loading = false
    errors = {}
    last_save: any | null = null

    notifiche = []

    getTextNotifica(notifica:any){
        switch (notifica.data.tipo){
            case TipoNotifica.AZIENDA_CREATA:
                return 'Approvazione azienda'
            case TipoNotifica.AZIENDA_APPROVATA:
                return 'Azienda approvata'
            case TipoNotifica.AZIENDA_RIFIUTATA:
                return 'Azienda rifiutata'
            case TipoNotifica.FORNITORE_CREATO:
                return 'Fornitore creato'
        }
        return 'Notifica'
    }

    getLinkNotifica(notifica:any){
        switch (notifica.data.tipo){
            case TipoNotifica.AZIENDA_CREATA:
            case TipoNotifica.AZIENDA_APPROVATA:
            case TipoNotifica.AZIENDA_RIFIUTATA:
                return {name:'DettaglioAzienda', params:{id:notifica.data.a_id}}
            case TipoNotifica.FORNITORE_CREATO:
                return {name:'DettaglioFornitore', params:{fid:notifica.data.f_id}}
        }
        return 'Notifica'
    }

    user_model = {
        id: 0,
        name: null,
        giorno_assunzione: null,
        telefono: null,
        ruolo: null,
        nascita: null,
        dipartimento: null,
        contatto_emergenza: null,
    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    created() {
        this.loading = true
        this.getCsrfCookie();
        this.fetchUser().then(()=>{
            this.fetchNotification()
        }).finally(() => {
            this.loading = false
        })
    }
    fetchNotification(){
        meManager.notifications().then((response:any)=>{
            this.notifiche = response.data
        });
    }

    fetchUser() {
        return meManager.me().then((response: any) => {
            this.user_model = response.data
        })
    }

    @Watch('user_model', {deep: true})
    debounceSave(old_val: any, new_val: any) {
        if (this.loading) return
        if (this.last_save) {
            clearTimeout(this.last_save)
            this.last_save = null
        }
        this.last_save = setTimeout(this.save, 1000)
    }

    save() {
        userManager.update(this.user_model.id, this.user_model).then((response) => {
            this.errors = {}
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            }
        })
    }

    getCsrfCookie(){
        this.axios.get('/sanctum/csrf-cookie')
    }

}
</script>


<style lang="scss">

</style>
